import { BaseResponse } from '@/types/common';
import axiosInstance from './axiosInstance';

const baseUrl = `${SUPP_ADMIN_BASE_URL}/supp-management`;

/**
 * 上传资源位图片
 * @param file 图片文件
 */
export const uploadResourcePositionImage = async (file: File) => {
  const formData = new FormData();
  formData.append('file', file);

  const resp = await axiosInstance.post<BaseResponse<string>>(
    `${baseUrl}/file/upload/resourcePositionImage`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return resp.data;
};
